// extracted by mini-css-extract-plugin
export default {"app":"app_app__zc9zm","footer":"app_footer__-zvhy","pageContent":"app_pageContent__yHdPg"};